import { t } from '../../i18n/translations';
import {
    ACTION__MODAL__TAB__JOBS,
    ACTION__MODAL__TAB__JOBS__INDUSTRY,
    ACTION__MODAL__TAB__POPULATION,
    ACTION__SETTLEMENT__HIRE_ASSISTANT,
    ACTION__SETTLEMENT__HIRE_BURNER,
} from '../../engine/input/actionIds';
import type { TutorialContext, TutorialStep } from './types';
import { getActiveJobsTabId, getActiveModal } from './helpers';

const ASSISTANT_TARGET = 2;
const BURNER_TARGET = 1;

export function buildColdSteps(ctx: TutorialContext): TutorialStep[] {
    const { state, settlement, settlementTileId, lang } = ctx;
    return [
        {
            id: 'click-city',
            title: t(lang, 'tutorial.cold.step1.title'),
            body: t(lang, 'tutorial.cold.step1.body'),
            target: { type: 'tile', tileId: settlementTileId },
            allowActionIds: [],
            condition: () => state.activeModalId === settlementTileId,
        },
        {
            id: 'open-population',
            title: t(lang, 'tutorial.cold.step2.title'),
            body: t(lang, 'tutorial.cold.step2.body'),
            target: { type: 'action', actionId: ACTION__MODAL__TAB__POPULATION },
            allowActionIds: [ACTION__MODAL__TAB__POPULATION],
            condition: () => getActiveModal(state)?.activeTabId === ACTION__MODAL__TAB__POPULATION,
        },
        {
            id: 'open-jobs',
            title: t(lang, 'tutorial.cold.step3.title'),
            body: t(lang, 'tutorial.cold.step3.body'),
            target: { type: 'action', actionId: ACTION__MODAL__TAB__JOBS },
            allowActionIds: [ACTION__MODAL__TAB__JOBS],
            condition: () => getActiveModal(state)?.activeTabId === ACTION__MODAL__TAB__JOBS,
        },
        {
            id: 'open-industry-jobs',
            title: t(lang, 'tutorial.cold.step4.title'),
            body: t(lang, 'tutorial.cold.step4.body'),
            target: { type: 'action', actionId: ACTION__MODAL__TAB__JOBS__INDUSTRY },
            allowActionIds: [ACTION__MODAL__TAB__JOBS__INDUSTRY],
            condition: () => getActiveJobsTabId(state) === ACTION__MODAL__TAB__JOBS__INDUSTRY,
        },
        {
            id: 'hire-burner',
            title: t(lang, 'tutorial.cold.step5.title'),
            body: t(lang, 'tutorial.cold.step5.body', BURNER_TARGET),
            target: { type: 'action', actionId: ACTION__SETTLEMENT__HIRE_BURNER },
            allowActionIds: [ACTION__SETTLEMENT__HIRE_BURNER],
            condition: () => (settlement ? settlement.jobs.burners >= BURNER_TARGET : false),
        },
        {
            id: 'hire-assistants',
            title: t(lang, 'tutorial.cold.step6.title'),
            body: t(lang, 'tutorial.cold.step6.body', ASSISTANT_TARGET),
            target: { type: 'action', actionId: ACTION__SETTLEMENT__HIRE_ASSISTANT },
            allowActionIds: [ACTION__SETTLEMENT__HIRE_ASSISTANT],
            condition: () => (settlement ? settlement.jobs.assistants >= ASSISTANT_TARGET : false),
        },
        {
            id: 'return-population',
            title: t(lang, 'tutorial.cold.step7.title'),
            body: t(lang, 'tutorial.cold.step7.body'),
            target: { type: 'action', actionId: ACTION__MODAL__TAB__POPULATION },
            allowActionIds: [ACTION__MODAL__TAB__POPULATION],
            condition: () => getActiveModal(state)?.activeTabId === ACTION__MODAL__TAB__POPULATION,
        },
    ];
}
